// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aOLP2lBHtAlE2HsQ0TZb{grid-template-columns:140px auto;display:grid}.aOLP2lBHtAlE2HsQ0TZb.TjHW6YRm258cAkczcyxn{row-gap:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid": `aOLP2lBHtAlE2HsQ0TZb`,
	"gridGap": `TjHW6YRm258cAkczcyxn`
};
export default ___CSS_LOADER_EXPORT___;
